import  { getOrganizationName } from "./tokenHelper";

export const getAircraftName = (e: string):string => {
  const organizationName = getOrganizationName();
  const splitText = e.replace(`${organizationName}-`, "").split("-");
  return `${splitText[0]}-${splitText[1]}`;
};
